// :cow: Cosmose CONFIDENTIAL :iso:
import { InjectionToken } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import * as reportStore from '../home/campaign/modules/report/store/report.reducers';
import * as reportState from '../home/campaign/modules/report/store/report.state';
import * as executionStore from '../home/campaign/modules/execution//store';
import * as languageStore2 from '@med/app/core/language/store';
import { AuthState, initialState as initialAuthState } from '@med/app/auth/store/auth.state';
import { authReducer } from '@med/app/auth/store/auth.reducers';
import { reducer } from '@med/app/home/campaign/store/campaign/campaign.reducers';
import { CampaignState, initialState as initialCampaignState } from '@med/app/home/campaign/store/campaign/campaign.state';

export interface State {
  auth: AuthState;
  campaign: CampaignState;
  report: reportState.ReportState;
  execution: executionStore.ExecutionState;
  language: languageStore2.LanguageState;
}

export const initialState = {
  auth: initialAuthState,
  campaign: initialCampaignState,
  report: reportState.initialState,
  execution: executionStore.initialState,
  language: languageStore2.initialState,
};

// Reducers
// -----------------------------------------
export const reducers = {
  auth: authReducer,
  campaign: reducer,
  report: reportStore.reducer,
  execution: executionStore.reducer,
  language: languageStore2.reducer,
};

//  Providers
// ----------------------------------------
export const REDUCER_TOKEN = new InjectionToken<ActionReducerMap<State>>('app.reducer');

export function getReducers() {
  return reducers;
}

export const reducerProvider = {
  provide: REDUCER_TOKEN,
  useFactory: getReducers,
};

